export class Location {

  public static instance = new Location();

  public href(): string {
    return window.location.href;
  }

  public setUrl(url: string) {
    window.location.href = url;
  }

  public search(): string {
    return window.location.search;
  }

  public replace(url: string) {
    window.location.replace(url);
  }

  public reload() {
    window.location.reload();
  }

  /**
   * Returns string in the form '#/somehash'
   */
  public hash(): string {
    return window.location.hash;
  }

  public setHash(newHash: string): void {
    window.location.hash = newHash;
  }
}
